import React from "react";
import { Section, SectionHeading } from "./Section";
import { storyQuestions } from "../data/framework";
export function StorySection() {
  return <Section tone="white" labelledBy="story-title" narrow cta="I want to review facelift cases with a system" data-id="element-285" data-mp="gyla5d5iccw9">
      <SectionHeading id="story-title" eyebrow="From studying facelift surgery in pieces…" title={<>
            …to reviewing cases <em className="text-gold-dark" data-id="element-287" data-mp="14oz6vgz1ezx6">with a system</em>
          </>} data-id="element-286" data-mp="bz8miq6tb1sm" />

      <div className="mt-10 space-y-5 text-[17px] leading-relaxed text-ink/90" data-id="element-288" data-mp="zs8qesjbm2b8">
        <p data-id="element-289" data-mp="vp2jdiodw73p">I created Facelift Blueprint™ because I noticed something that is rarely addressed clearly in surgical education.</p>
        <p data-id="element-290" data-mp="qppoqbr9tvqk">
          You can watch lectures. You can read textbooks. You can attend conferences. You can study different facelift techniques.
        </p>
        <p className="font-semibold text-ink" data-id="element-291" data-mp="3bgzxcc6gswg2">And still find yourself looking at a new case wondering:</p>

        <ul className="space-y-3" data-id="element-292" data-mp="1o76c5jvw99rf">
          {storyQuestions.map(q => <li key={q} className="border-l-4 border-gold bg-gold-soft/60 py-3 pl-4 pr-3 font-serif text-lg italic text-navy" data-id="element-293" data-mp="1o5v4va38pjvk">
              “{q}”
            </li>)}
        </ul>

        <p data-id="element-294" data-mp="1f9478t91hwyv">I wanted to create something that would help you bring those pieces together.</p>
        <p className="font-semibold" data-id="element-295" data-mp="1k87b4ada9x59">
          Not another massive course.
          <br data-id="element-296" data-mp="15fn9xf9p1zqg" />
          Not another collection of disconnected notes.
        </p>
        <p data-id="element-297" data-mp="1a8yibku5mokh">
          A structured educational system you can return to whenever you want to review facelift cases, organize your learning, and
          document the questions that matter.
        </p>
        <p data-id="element-298" data-mp="10j57im1u6dha">That's why I created Facelift Blueprint™.</p>
      </div>

      <div className="mt-8 rounded-2xl bg-navy px-5 py-6 text-center text-white sm:px-8" data-id="element-299" data-mp="mim5bvk1y1n1">
        <p className="font-serif text-2xl font-bold leading-snug sm:text-3xl" data-id="element-300" data-mp="rhfexcw7x8hx">
          One case. One framework. <span className="text-gold-light" data-id="element-301" data-mp="2t6cp1o8dbyvw">One structured review in approximately 15 minutes.</span>
        </p>
      </div>

      <div className="mt-8 space-y-4 text-[17px] leading-relaxed text-ink/90" data-id="element-302" data-mp="2ofmlmgji663u">
        <p data-id="element-303" data-mp="2kdrj58pu5moh">The goal isn't to replace your clinical judgment or formal surgical training.</p>
        <p className="font-semibold text-ink" data-id="element-304" data-mp="2ffg84unt164o">It's to help you get more value from the knowledge you're already building.</p>
      </div>
    </Section>;
}